import { Route } from 'react-router-dom';
import { routes } from '../../utils/helpers/ApiClient';
import CMSWrapper from '../CMSWrapper';
import {
  AttendanceEventsPage,
  AttendanceEventEdit,
  AttendanceSchedulePage,
  AttendanceEventDetail,
  AttendanceOverviewPage,
} from '../pages/CMSPages/index';

import React from 'react';

const AttendanceRoutes = () => (
  <>
    <Route
      path={routes.cmsAttendanceStudentOverview}
      element={
        <CMSWrapper permissions={['attendance.index']}>
          <AttendanceOverviewPage mode={'student'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsAttendanceTeacherOverview}
      element={
        <CMSWrapper permissions={['attendance.show']}>
          <AttendanceOverviewPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsAttendanceEvents}
      element={
        <CMSWrapper permissions={['attendance-events.admin']}>
          <AttendanceEventsPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsAttendanceMyEvents}
      element={
        <CMSWrapper permissions={['attendance-events.show']}>
          <AttendanceEventsPage all={false} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsAttendanceCreateScheduleEvent}
      element={
        <CMSWrapper permissions={['attendance-events.store']}>
          <AttendanceEventEdit mode={'schedule'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsAttendanceCreateCustomEvent}
      element={
        <CMSWrapper permissions={['attendance-events.store']}>
          <AttendanceEventEdit mode={'custom'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsAttendanceEventDetail}/:att_event_id`}
      element={
        <CMSWrapper permissions={['attendance.update']}>
          <AttendanceEventDetail />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsAttendanceSchedule}
      element={
        <CMSWrapper permissions={['attendance-events.schedule']}>
          <AttendanceSchedulePage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsAttendanceSchedule}/:teacher_id`}
      element={
        <CMSWrapper permissions={['attendance-events.schedule']}>
          <AttendanceSchedulePage />
        </CMSWrapper>
      }
    />
  </>
);

export default AttendanceRoutes;
